export enum AccountRole {
  ClientAdmin = 'CLIENTADMIN',
  OrderManager = 'ORDERMANAGER',
  SigningAgent = 'SIGNINGAGENT',
  SettlementAgent = 'SETTLEMENTAGENT',
}

